module.exports = __webpack_public_path__ + "img/23.f601fbb1.jpg";